// extracted by mini-css-extract-plugin
module.exports = {"divider":"ReadingLogs_divider__zbcbG","title":"ReadingLogs_title__2X1Fp","spacer":"ReadingLogs_spacer__2CIFm","rightBtnCol":"ReadingLogs_rightBtnCol__34Bm9"};